module.exports = __webpack_public_path__ + "static/media/xero.b2a9cfa0.svg";